import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const DataImport: React.FC = () => {
  return (
    <PageTemplate
      title="Data Import"
      description="Import data into Salesforce from various sources"
    />
  );
};